import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  InternalAdminEditUserMutation,
  InternalAdminEditUserMutationVariables,
  InternalAdminUserFragment,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import INTERNAL_ADMIN_EDIT_USER_MUTATION from "../_networking/internal-admin-edit-user";

interface IProps {
  user: InternalAdminUserFragment;
}

const InternalAdminEditUserAllDistributionGroups = ({ user }: IProps) => {
  const [internalAdminEditUserMutationAPI] = useMutation<
    InternalAdminEditUserMutation,
    InternalAdminEditUserMutationVariables
  >(INTERNAL_ADMIN_EDIT_USER_MUTATION);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      internalAdminEditUserMutationAPI({
        variables: {
          organizationId: user.organizationId,
          id: user.id,
          input: {
            isAllDistributionGroups: e.target.checked === true,
          },
        },
        fetchPolicy: "network-only",
      });
    },
    [internalAdminEditUserMutationAPI, user],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={user.isAllDistributionGroups}
      onChange={onChange}
    />
  );
};

export default memo(InternalAdminEditUserAllDistributionGroups);
